import React, { useMemo } from 'react';
import { ThemeProvider } from '@mui/material/styles';
import { CssBaseline } from '@mui/material';
import { createAppTheme } from './createAppTheme';
import { useDevNightThemeSnapshot } from '../hooks/useDevNightThemeSnapshot';

/**
 * Thème MUI synchronisé sur `data-dev-night-mode` et `data-night-palette` (toggle + palettes dev).
 */
export const DynamicMuiThemeProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const { isDark, paletteId } = useDevNightThemeSnapshot();

  const theme = useMemo(
    () => createAppTheme(isDark ? 'dark' : 'light', paletteId),
    [isDark, paletteId]
  );

  return (
    <ThemeProvider theme={theme}>
      <CssBaseline enableColorScheme />
      {children}
    </ThemeProvider>
  );
};
